import { Component, Input, ViewEncapsulation } from '@angular/core';
import { OperatingSystemName } from '@core/constants';

@Component({
  selector: 'caremoni-logo-tv',
  templateUrl: './logo-tv.component.html',
  styleUrl: './logo-tv.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class LogoTvComponent {
    @Input() title: string = '';
    @Input() width: number = 60;
    OS = OperatingSystemName;
    
    currentOS: string | null = '';
}
